<mat-card [class]="mode">
  <div class="alert-message">
    @if (getIcon(); as icon) {
      <ui-icon [faName]="icon" faStyle="light"></ui-icon>
    }
    <span [innerHTML]="message" class="message"></span>
  </div>
  @if (linkHref) {
    <a [attr.href]="linkHref" [attr.target]="linkTarget ?? '_self'" [innerHTML]="linkLabel ?? ''" class="action"></a>
  }
</mat-card>
